export interface IRawMaterial {
    teId: string;
    certifiedRmCode: string;
    lastUpdated: string; // ISO 8601 date-time string
    rmDescription: string;
    balance: number;
}
  
export const mapApiResponseToRawMaterial = (apiResponse: any[]): IRawMaterial[] => {
  return apiResponse.map((item) => ({
    teId: item.teId || '',
    certifiedRmCode: item.certifiedRmCode || '',
    lastUpdated: item.lastUpdated || '',
    rmDescription: item.rmDescription || '',
    balance: Number(Number(item.balance).toFixed(2)) || 0, // Ensure it's a number
  }));
};

export type RawMaterialRecords = IRawMaterial[];